// NSA-HS Style 41 Bobbins
import React from "react";
import {
   BackPressureSpringRow, CommonRows, FeederTensionSettingRow, FeederWrapsRow, ImpulseSettingRow, LayWheelSettingRow,
   LubeRollerRow, RunTimeRow, SpeedRow, TensionPostSettingRow, TensionRow, ThreadBreakTimeoutRow, ThreadGuideRow,
   TimeConveyorRow, TimeDepositRow, UnderWindDRow, UnderWindLRow, UnderWindSRow, YardsRow
} from "./index";

export default function MachineHacoba() {
   return (
      <>
         <ImpulseSettingRow />
         <RunTimeRow />
         <SpeedRow />
         <LubeRollerRow />
         <TensionRow />
         <TimeDepositRow />
         <ThreadBreakTimeoutRow />
         <UnderWindSRow />
         <UnderWindDRow />
         <UnderWindLRow />
         <ThreadGuideRow />
         <TimeConveyorRow />
         <LayWheelSettingRow />
         <TensionPostSettingRow />
         <BackPressureSpringRow />
         <FeederTensionSettingRow />
         <FeederWrapsRow />
         <YardsRow />
         <CommonRows />
      </>
   );
}
